define('models/Credential',[
	'core/can',
	'models/Session',
	'models/Base'
], function (can, Session, Base) {

	// TODO
	// reuse model in onboarding, merge validations

	var Credential = Base.extend({

		findAll: 'GET /Credentials',
		findOne: 'GET /Credentials/{id}',
		create: 'POST /Credentials',
		update: 'PUT /Credentials',
		destroy: 'DELETE /Credentials/{id}'

	}, {

			define: {
				Username: {
					type: 'string'
				},
				Password: {
					type: 'string'
				},
				Pin: {
					type: 'string'
				},
				IsVerified: {
					type: 'boolean'
				},
				IsActive: {
					type: 'boolean'
				},
				Linkage: {
					ProviderId: {
						type: 'String'
					},
					LinkageStatus: {
						type: 'Number'
					}
				},
				IntermediaryIdentifier: {
					type: 'number',
					value: 1
				}
				// MedicareIntermediaryId: "4955d02f5f39403fa1bd6f5e0c8c8525"
				// IsInUse: null
			},

			_IsActive: can.compute(function() {
				return this.attr('IsActive');
			}),

			_IsLinked: can.compute(function () {
				return this.attr('IsVerified');
			})
		});

	Credential.rules = {
		Username: {
			validators: {
				notEmpty: {
					message: 'Required'
				},
				stringLength: {
					min: 7,
					max: 7,
					message: 'Must be 7 characters long'
				},
				regexp: {
					regexp: /^([a-zA-Z]{2}\d{5}|[a-zA-Z]{3}\d{4})/,
					message: 'Must start with 2 or 3 letters, followed by numbers'
				}
			}
		},
		Password: {
			validators: {
				notEmpty: {
					message: 'Required'
				},
				stringLength: {
					min: 8,
					max: 8,
					message: 'Must be exactly 8 characters long'
				}
			}
		},
		Pin: {
			validators: {
				notEmpty: {
					message: 'Required'
				},
				stringLength: {
					min: 4,
					message: 'Must be at least 4 characters long'
				}
			}
		},
		IntermediaryIdentifier: {
			validators: {
				notEmpty: {
					message: 'Required'
				}
			}
		}
	};

	return Credential;
});
